// Translations for GeoCheck App
export const translations = {
  en: {
    appName: "GeoCheck",
    workLocationStatus: "Work location status",
    checkingLocationStatus: "Checking location status...",
    insideAllowedArea: "Inside allowed area",
    outsideAllowedArea: "Outside allowed area",
    assignedLocations: "Assigned locations",
    allowedRadius: "Allowed radius",
    geofenceNoAssignment: "Your employer must assign a work location first.",
    geofenceOutside: "You are outside the allowed check-in area.",
    signIn: "Sign In",
    signOut: "Sign out",
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    submit: "Submit",
    refresh: "Refresh",
    history: "History",
    settings: "Settings",
    profile: "Profile",
    actions: "Actions",
    status: "Status",
    remove: "Remove",
    approve: "Approve",
    deny: "Deny",
    pending: "Pending",
    approved: "Approved",
    denied: "Denied",
    assigned: "Assigned",
    heroTagline: "GPS-Verified Attendance",
    heroTitle: "Verified check-ins with",
    heroPrecision: "location & time accuracy",
    heroDescription: "Every check-in is verified by GPS location and shift time. Know exactly when and where your team clocks in — no guesswork, no buddy punching.",
    heroTrust: "Trusted by shift-based teams in retail, hospitality, and field services",
    heroVerified: "Location verified",
    getStartedFree: "Get Started Free",
    navFeatures: "Features",
    navPricing: "Pricing",
    featuresTitle: "Built for accurate, verified attendance",
    featuresSubtitle: "Every feature designed to eliminate manual tracking and attendance confusion.",
    featureGPS: "GPS Location Verification",
    featureGPSDesc: "Every check-in captures precise GPS coordinates. Verify your team is where they say they are.",
    featureTime: "Automatic Time Tracking",
    featureTimeDesc: "Timestamps are captured automatically — no manual entry, no time theft.",
    featureSchedule: "Group Schedule",
    featureScheduleDesc: "Teams-style calendar view to manage shifts and see your entire workforce at a glance.",
    featurePayroll: "Payroll Export",
    featurePayrollDesc: "Export detailed attendance and hours reports in CSV or PDF with one click.",
    featureTeam: "Team Overview",
    featureTeamDesc: "Real-time dashboard showing who's working, who's late, and who's on time off.",
    featureSecurity: "Secure & Private",
    featureSecurityDesc: "Location captured only at check-in — not continuous tracking. Your team's privacy matters.",
    featureAnalytics: "Company-Wide Analytics",
    featureAnalyticsDesc: "Track attendance rates, late patterns, hours worked, and team performance across your entire organization.",
    coreFeature: "Core Feature",
    mostUsed: "Most Used",
    mobileTagline: "Mobile-first design",
    mobileTitle: "Check in from anywhere",
    mobileDescription: "Whether your team is in the field, at a client site, or working remotely, they can check in with just one tap.",
    mobileFeature1: "One-tap check-in and check-out",
    mobileFeature2: "Automatic GPS location capture",
    mobileFeature3: "View your attendance history",
    mobileFeature4: "Works offline, syncs when connected",
    ctaTitle: "Stop guessing. Start verifying.",
    ctaDescription: "Eliminate manual tracking, prevent time theft, and end attendance confusion. GeoCheck gives you the accuracy your business needs.",
    welcomeTitle: "Welcome",
    roleQuestion: "Let's get you set up. Are you an employer or an employee?",
    imEmployer: "I'm an Employer",
    employerDesc: "Create a company and invite employees to track their attendance.",
    imEmployee: "I'm an Employee",
    employeeDesc: "Join your company with an invite code to start checking in.",
    createCompany: "Create Your Company",
    joinCompany: "Join Your Company",
    companyNameLabel: "Company Name",
    companyNamePlaceholder: "Enter your company name",
    inviteCodeLabel: "Invite Code",
    inviteCodePlaceholder: "Enter invite code (e.g., ABC123XY)",
    displayNameLabel: "Your Display Name",
    displayNamePlaceholder: "Enter your full name (First Last)",
    displayNameHelp: "This is how your employer will see your name",
    joiningCompany: "Joining",
    continue: "Continue",
    currentlyCheckedIn: "Currently Checked In",
    notCheckedIn: "Not Checked In",
    checkIn: "Check In",
    checkOut: "Check Out",
    gettingLocation: "Getting location...",
    activityHistory: "Activity History",
    noActivity: "No activity for this date",
    checkedIn: "Checked In",
    checkedOut: "Checked Out",
    late: "Late",
    onTime: "On Time",
    requestTimeOff: "Request Time Off",
    timeOffRequests: "Time Off Requests",
    selectDate: "Select Date",
    reasonType: "Reason",
    reasonDetails: "Additional Details (Optional)",
    reasonDetailsPlaceholder: "Enter any additional information...",
    submitRequest: "Submit Request",
    noTimeOffRequests: "No time off requests",
    realTimeAttendance: "Real-time employee attendance dashboard",
    inviteCode: "Invite Code",
    totalEmployees: "Total Employees",
    currentlyWorking: "Currently Working",
    notCheckedInCount: "Not Checked In",
    employeeStatus: "Employee Status",
    realTimeStatus: "Real-time check-in status of all employees",
    noEmployeesYet: "No employees yet",
    shareInviteCode: "Share your invite code with employees to get started",
    employee: "Employee",
    lastCheckIn: "Last Check-in",
    lastLocation: "Last Location",
    working: "Working",
    offline: "Offline",
    timeOff: "Time Off",
    analytics: "Analytics",
    viewAnalytics: "View Analytics",
    period: "Period",
    week: "Week",
    month: "Month",
    year: "Year",
    totalDaysWorked: "Total Days Worked",
    lateDays: "Late Days",
    onTimeDays: "On Time Days",
    totalHours: "Total Hours",
    avgHoursPerDay: "Avg Hours/Day",
    attendanceRate: "Attendance Rate",
    dailyBreakdown: "Daily Breakdown",
    employeeManagement: "Employee Management",
    manageEmployees: "Manage Employees",
    allEmployees: "All Employees",
    removeEmployee: "Remove Employee",
    confirmRemove: "Are you sure you want to remove this employee?",
    employeeRemoved: "Employee removed successfully",
    companySettings: "Company Settings",
    autoReset: "Auto Reset Status",
    autoResetDesc: "Reset status for employees who forgot to check out",
    runNow: "Run Now",
    clearLateNotifications: "Clear Late Notifications",
    clearLateNotificationsDesc: "Archive all late notifications",
    languageSettings: "Language",
    selectLanguage: "Select Language",
    securityAlerts: "Security Alerts",
    ipFlags: "IP Flags",
    ipFlagDescription: "Multiple employees logged in from the same device",
    noSecurityAlerts: "No security alerts",
    flaggedUsers: "Flagged Users",
    checkInSuccess: "Checked in successfully!",
    checkOutSuccess: "Checked out successfully!",
    lateReasonUpdated: "Late reason submitted",
    profileUpdated: "Profile updated successfully",
    settingsSaved: "Settings saved",
    requestSubmitted: "Request submitted",
    copiedToClipboard: "Copied to clipboard!",
    locationDenied: "Location access denied",
    // Notifications
    lateCheckInNotifications: "Late Check-in Notifications",
    lateNotificationsDesc: "View late check-ins from employees with their reasons (last 30 days)",
    noLateCheckIns: "No late check-ins in the last 30 days",
    greatJobOnTime: "Great job keeping your team on time!",
    lateCheckIn: "Late Check-in",
    reasonProvided: "Reason provided:",
    noReasonProvided: "No reason provided",
    notificationsCleared: "Notifications cleared",
    clearNotifications: "Clear All Notifications?",
    clearNotificationsDesc: "This will archive all late notifications. They will still be available in the audit history.",
    // Pay Types
    payType: "Pay Type",
    hourly: "Hourly",
    salary: "Salary",
    hourlyDesc: "Flexible shift-based scheduling",
    salaryDesc: "Fixed weekly schedules",
    payTypeLabel: "Employee Pay Type",
    hourlyPayTypeHelp: "Employees request shifts or are assigned shifts",
    salaryPayTypeHelp: "Set permanent weekly schedules for employees",
    // Permanent Schedule
    setSchedule: "Set Weekly Schedule",
    settingScheduleFor: "Setting schedule for",
    pendingSchedules: "Employees Need Schedules",
    myPermanentSchedule: "My Weekly Schedule",
    permanentScheduleDesc: "Your regular working hours set by your employer",
    requestScheduleAdjustment: "Request Schedule Adjustment",
    scheduleSet: "Schedule set successfully",
    dayOff: "Day Off",
    salaryScheduleNote: "Showing permanent schedules. Shift adjustments and time-off override permanent times.",
    permanentSchedule: "Permanent Schedule",
    shiftAdjustment: "Shift / Adjustment",
    // Days of week
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    // Employee actions
    jobTitle: "Job Title",
    jobTitlePlaceholder: "e.g. Software Engineer",
    leaveCompany: "Leave Company",
    leaveCompanyConfirm: "Are you sure you want to leave this company? This action cannot be undone.",
    leave: "Leave",
    leftCompanySuccess: "Successfully left company",
    // Shift Scheduling
    schedule: "Schedule",
    groupSchedule: "Group Schedule",
    mySchedule: "My Schedule",
    shiftRequests: "Shift Requests",
    requestShift: "Request Shift",
    assignShift: "Assign Shift",
    availability: "Availability",
    setAvailability: "Set Availability",
    myAvailability: "My Availability",
    startTime: "Start Time",
    endTime: "End Time",
    shiftDate: "Shift Date",
    noShifts: "No shifts scheduled",
    noShiftRequests: "No shift requests",
    shiftApproved: "Shift approved",
    shiftDenied: "Shift denied",
    shiftAssigned: "Shift assigned",
    weeklySchedule: "Weekly Schedule",
    previousWeek: "Previous Week",
    nextWeek: "Next Week",
    today: "Today",
    todayShift: "Today's Shift",
    timeOffRemoved: "Time off removed",
    removeTimeOff: "Remove time off",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    available: "Available",
    notAvailable: "Not Available",
    // Export
    exportReport: "Export Report",
    exportPayroll: "Export Payroll",
    downloadCSV: "Download CSV",
    startDate: "Start Date",
    endDate: "End Date",
    export: "Export",
    // Reasons
    "reasons.sick": "Sick Leave",
    "reasons.personal": "Personal Day",
    "reasons.vacation": "Vacation",
    "reasons.family_emergency": "Family Emergency",
    "reasons.appointment": "Appointment",
    "reasons.other": "Other",
    // New features
    totalAnalytics: "Total Analytics",
    companyAnalytics: "Company Analytics",
    exportSchedule: "Export Schedule",
    weeklyExport: "Weekly Export",
    monthlyExport: "Monthly Export",
    lateReason: "Reason for being late",
    enterLateReason: "Please enter the reason for your late check-in",
    lateReasonPlaceholder: "Enter reason...",
    flaggedIP: "Flagged: Same IP as other employee",
    flaggedLate: "Flagged: Late check-in",
    employerNotes: "Employer Notes",
    addNotes: "Add Notes",
    notesPlaceholder: "Enter notes for employee...",
    shiftsEnabled: "Shift Scheduling Enabled",
    shiftsDisabled: "Shift Scheduling Disabled",
    enableShifts: "Enable Shifts",
    disableShifts: "Disable Shifts",
    companyTimezone: "Company Timezone",
    timezoneHelp: "Used for late check-in detection and schedule times",
    dateRange: "Date Range",
    excludeDays: "Exclude Days",
    selectDaysToExclude: "Select days to exclude",
    bulkApprove: "Bulk Approve",
    bulkDeny: "Bulk Deny",
    viewLiveStatus: "Live Status",
    viewAllEmployees: "All Employees",
    // General
    singleDay: "Single Day",
    dateRange: "Date Range",
    excludeDays: "Exclude Days",
    selectDaysToExclude: "Click days to exclude from range",
    monday: "Mon",
    tuesday: "Tue", 
    wednesday: "Wed",
    thursday: "Thu",
    friday: "Fri",
    saturday: "Sat",
    sunday: "Sun",
    // Pricing
    freeTrial: "Free Trial",
    basicPlan: "Basic",
    proPlan: "Pro",
    enterprisePlan: "Enterprise",
    perMonth: "/month",
    contactUs: "Contact Us",
    startFreeTrial: "Start Free Trial",
    getStarted: "Get Started",
    // New Pricing
    pricingTitle: "Simple pricing for every team size",
    pricingSubtitle: "All plans include all features. Choose based on your team size.",
    welcomeNewEmployer: "Welcome to GeoCheck!",
    welcomeNewEmployerDesc: "Your company has been created. Choose a plan to unlock all features, or continue with your 10-day free trial.",
    skipForNow: "Skip for Now",
    goToDashboard: "Go to Dashboard",
    planStarter: "Starter",
    planStarterDesc: "Try all features risk-free",
    planStarterTeam: "Up to 5 employees",
    planStarterFeature1: "10-day free trial",
    planStarterFeature2: "No credit card required",
    planGrowth: "Growth",
    planGrowthDesc: "Perfect for small teams",
    planGrowthTeam: "Up to 20 employees",
    planGrowthFeature1: "Email support",
    planGrowthFeature2: "1 admin account",
    planBusiness: "Business",
    planBusinessDesc: "Best for growing companies",
    planBusinessTeam: "Up to 60 employees",
    planBusinessFeature1: "Priority support",
    planBusinessFeature2: "Unlimited admins",
    planBusinessFeature3: "Advanced analytics",
    planProfessional: "Professional",
    planProfessionalDesc: "For established businesses",
    planProfessionalTeam: "Up to 100 employees",
    planProfessionalFeature1: "Priority support",
    planProfessionalFeature2: "Advanced analytics",
    planProfessionalFeature3: "Custom reports",
    planEnterprise: "Enterprise",
    planEnterpriseDesc: "For large organizations",
    planEnterpriseTeam: "Unlimited employees",
    planEnterpriseFeature1: "Dedicated account manager",
    planEnterpriseFeature2: "Custom integrations",
    planEnterpriseFeature3: "SLA guarantee",
    allFeaturesIncluded: "All features included",
    // Footer
    footerTagline: "GPS-verified attendance for modern teams",
    footerTrust: "Built for shift-based teams in retail, hospitality, and field services",
    footerProduct: "Product",
    footerSupport: "Support",
    footerLegal: "Legal",
    // Legal
    termsOfService: "Terms of Service",
    privacyPolicy: "Privacy Policy",
    allRightsReserved: "All Rights Reserved",
    // Clear & Audit
    clearAll: "Clear All",
    auditHistory: "Audit History",
    resetAnalytics: "Reset Analytics",
    // Employee Dashboard UX
    noActivityHelp: "Check-ins and check-outs will appear here",
    checkInMicrocopy: "Your GPS location will be recorded for attendance verification",
    checkOutMicrocopy: "Click to record your departure time and location",
    howCheckInWorks: "How check-in works",
    helpStep1Title: "GPS Location Capture",
    helpStep1Desc: "Your location is recorded only at the moment you check in or out — never tracked in between.",
    helpStep2Title: "Late Detection",
    helpStep2Desc: "If you check in after your scheduled start time, you'll be marked as late and asked for a reason.",
    helpStep3Title: "Check Out",
    helpStep3Desc: "Don't forget to check out when you leave. If you forget, your status will reset automatically the next day.",
    helpPrivacyNote: "Your privacy matters. Location data is only captured during check-in/out actions.",
    gotIt: "Got it",
    shiftRequestsHelp: "Track your requests and employer responses",
    noShiftRequestsHelp: "Submit a request using the form on the left",
    timeOffRequestsHelp: "Your submitted requests and their status",
    noTimeOffRequestsHelp: "Submit a request using the form on the left",
    trialActive: "Company Trial Active",
    trialEmployeeNote: "Your employer's trial ends in",
    days: "days",
    hours: "hours",
    you: "You",
    yourShifts: "Your shifts are highlighted",
    // Employer Dashboard UX - Iteration 11
    currentlyWorkingNow: "Currently Working (Now)",
    lateToday: "Late Today",
    liveStatusHelper: "Live status updates automatically every 30 seconds",
    viewActivity: "View activity",
    dangerZone: "Danger Zone",
    deleteCompany: "Delete Company",
    deleteCompanyTitle: "Delete Company?",
    deleteCompanyWarning: "This action will permanently delete your company and all associated data including employees, shifts, time-off requests, and analytics. All employees will be removed from the company.",
    finalConfirmation: "Final Confirmation Required",
    deleteCompanyFinalWarning: "You are about to permanently delete your company. This action CANNOT be undone.",
    allEmployeesRemoved: "All employees will be removed from the company",
    allDataDeleted: "All shifts, time-off requests, and analytics will be deleted",
    subscriptionCancelled: "Your subscription will be cancelled",
    typeDelete: "Type",
    toConfirm: "to confirm",
    attendanceAlerts: "Attendance Alerts",
    attendanceAlertsDesc: "Late check-ins indicate potential scheduling or transportation issues. Tracking these helps identify patterns and improve team punctuality.",
    ipFlagExplanation: "IP flags detect when multiple employees check in from the same device/network. This helps identify potential buddy punching or time fraud.",
    noSecurityAlertsHelper: "No suspicious check-in activity detected",
    auditHistoryDesc: "Cleared data is archived here for accountability and compliance. This maintains a record of all shift requests, time-off requests, late check-ins, and IP flags that have been cleared.",
    shiftRequestsDesc: "Review and approve employee shift requests",
    shiftRequestsEmptyHelper: "Shift requests from employees will appear here",
    timeOffRequestsDesc: "Review and approve employee time-off requests",
    timeOffRequestsEmptyHelper: "Time-off requests from employees will appear here",
    // Subscription Management
    manageSubscription: "Manage Subscription",
    cancelSubscription: "Cancel Subscription",
    cancelSubscriptionTitle: "Cancel Subscription?",
    cancelSubscriptionWarning: "Your subscription will be cancelled at the end of the current billing period. You will lose access to all premium features.",
    subscriptionCancelledSuccess: "Your subscription has been cancelled",
    reactivateSubscription: "Reactivate Subscription",
    subscriptionStatus: "Subscription Status",
    currentPlan: "Current Plan",
    billingCycle: "Billing Cycle",
    nextBillingDate: "Next Billing Date",
    // Additional translations
    freeTrialActive: "Free Trial Active",
    remaining: "remaining",
    employees: "employees",
    upgradeNow: "Upgrade Now",
    activeSubscription: "Active Subscription",
    plan: "Plan",
    ipFlag: "IP Flag",
    reason: "Reason",
    active: "Active",
    // Analytics Tab
    companyWideMetrics: "Company-wide attendance metrics",
    resetAll: "Reset All",
    employeeBreakdown: "Employee Breakdown",
    rate: "Rate",
    // Security Tab
    multipleLoginsFromDevice: "Multiple logins from same device",
    ipAddress: "IP",
    // Audit History Tab
    all: "All",
    shifts: "Shifts",
    lateAlerts: "Late Alerts",
    clearedShiftRequests: "Cleared Shift Requests",
    clearedTimeOffRequests: "Cleared Time Off Requests",
    clearedIpFlags: "Cleared IP Flags",
    clearedLateNotifications: "Cleared Late Notifications",
    cleared: "Cleared",
    lateCheckIn: "Late check-in",
    // Subscription Auto-Renewal
    autoRenewalEnabled: "Auto-renewal enabled",
    autoRenewalDisabled: "Auto-renewal disabled",
    monthlyBilling: "Monthly billing",
    subscriptionRenewsAutomatically: "Your subscription renews automatically each month",
    // Auth Page
    loginDescription: "Sign in to your account",
    registerDescription: "Create a new account",
    fullName: "Full Name",
    enterName: "Enter your name",
    email: "Email",
    enterEmail: "Enter your email",
    password: "Password",
    enterPassword: "Enter password",
    confirmPassword: "Confirm Password",
    confirmPasswordPlaceholder: "Confirm your password",
    signUp: "Sign up",
    createAccount: "Create Account",
    noAccount: "Don't have an account?",
    haveAccount: "Already have an account?",
    backToHome: "Back to home",
    passwordsDoNotMatch: "Passwords do not match",
    passwordTooShort: "Password must be at least 6 characters",
    nameRequired: "Name is required",
    loginFailed: "Login failed",
    registrationFailed: "Registration failed",
    loginSuccess: "Welcome back!",
    accountCreated: "Account created!",
    networkError: "Network error. Please try again.",
    pleaseWait: "Please wait...",
    // Forgot Password
    forgotPassword: "Forgot password?",
    forgotPasswordDesc: "Enter your email and we'll send you a reset link",
    sendResetLink: "Send Reset Link",
    resetEmailSent: "Password reset email sent!",
    resetEmailSentDesc: "We've sent a password reset link to your email address. Please check your inbox.",
    resetEmailFailed: "Failed to send reset email",
    checkYourEmail: "Check your email for the reset link",
    sending: "Sending...",
    backToLogin: "Back to Login",
    resetPassword: "Reset Password",
    resetPasswordDesc: "Enter your new password below",
    newPassword: "New Password",
    passwordMinLength: "Password must be at least 6 characters",
    invalidResetLink: "Invalid or missing reset link",
    resetFailed: "Failed to reset password",
    passwordResetSuccess: "Password reset successful!",
    passwordResetSuccessDesc: "Your password has been reset successfully",
    canNowLogin: "You can now login with your new password",
    goToLogin: "Go to Login",
    resetting: "Resetting...",
    // Pricing Tab Admin
    pricingPlans: "Pricing Plans",
    managePricing: "Manage subscription pricing and employee limits",
    planName: "Plan Name",
    priceSAR: "Price (SAR)",
    maxEmployees: "Max Employees",
    description: "Description",
    editPlan: "Edit",
    savePlan: "Save",
    deletePlan: "Delete Plan",
    deletePlanConfirm: "This will permanently delete this pricing plan.",
    planUpdated: "Plan updated successfully",
    planDeleted: "Plan deleted",
    customPrice: "Custom Price",
    multiEmployer: "Multi-Employer",
    multiEmployerEnabled: "Multiple employers enabled",
    multiEmployerDisabled: "Multiple employers disabled",
    multiEmployerInvite: "Invite Another Employer",
    multiEmployerInviteDesc: "Share this link with another person to invite them as an employer for your company. They will have full employer access.",
    multiEmployerInviteNote: "Note: The invited person must select 'I'm an Employer' and enter this invite code during registration.",
    employerInviteLinkCopied: "Employer invite link copied!",
    employerInviteBanner: "You've been invited to join",
    asEmployer: "as an employer",
    joinAsEmployer: "Join as Employer",
    joinAsEmployerDesc: "You've been invited to join this company as an employer.",
    // Landing page dynamic pricing
    trialDays: "10 days",
    month: "month",
    upTo: "Up to",
    // Terms and Privacy
    termsTitle: "Terms of Service",
    privacyTitle: "Privacy Policy",
    lastUpdated: "Last Updated",
    // Admin Access
    adminAccess: "Admin Access",
    manageAllUsersCompanies: "Manage all users, companies, and pricing",
    openAdminDashboard: "Admin Dashboard",
    unrestricted: "Unrestricted",
    adminCompany: "Admin Company",
    checkoutLinkGenerated: "Checkout link generated!",
    linkCopied: "Link copied to clipboard!",
    generateLink: "Generate Link",
    setCustomPricing: "Set Custom Pricing",
    // Admin Dashboard
    adminDashboard: "Admin Dashboard",
    exitAdmin: "Exit Admin",
    totalUsers: "Total Users",
    companiesCount: "Companies",
    activeSubscriptions: "Active Subscriptions",
    trialUsers: "Trial Users",
    companiesTab: "Companies",
    usersTab: "Users",
    transactionsTab: "Transactions",
    pricingTab: "Pricing",
    manageCompanySubscriptions: "Manage company subscriptions and trials",
    company: "Company",
    owner: "Owner",
    employeesCount: "Employees",
    trialDaysColumn: "Trial Days",
    customEnterprise: "Custom Enterprise",
    multiEmployer: "Multi-Employer",
    edit: "Edit",
    set: "Set",
    link: "Link",
    editCompany: "Edit Company",
    subscriptionStatusLabel: "Subscription Status",
    subscriptionPlanLabel: "Subscription Plan",
    trialDaysLabel: "Trial Days",
    manageTrial: "Manage Trial",
    addTrialDays: "Add Days",
    setTrialDays: "Set Days",
    resetTrial: "Reset Trial",
    trialExtended: "Trial extended",
    trialSet: "Trial set",
    trialResetSuccess: "Trial reset to 10 days",
    manageUsers: "Manage platform users and permissions",
    // Pricing Tab
    pricingPlans: "Pricing Plans",
    managePricing: "Manage subscription pricing and employee limits",
    planName: "Plan Name",
    priceSAR: "Price (SAR)",
    maxEmployees: "Max Employees",
    description: "Description",
    deletePlan: "Delete Plan",
    deletePlanConfirm: "This will permanently delete this pricing plan. Companies on this plan will not be affected, but no new subscriptions can use this plan.",
    freeTrial: "Free",
    unlimited: "Unlimited",
    contactSales: "Contact Sales",
    name: "Name",
    role: "Role",
    joined: "Joined",
    makeAdmin: "Make Admin",
    revokeAdmin: "Revoke Admin",
    adminRightsGranted: "Admin rights granted",
    adminRightsRevoked: "Admin rights revoked",
    confirmMakeAdmin: "Grant Admin Rights?",
    confirmMakeAdminDesc: "This will give the user full admin access to manage all companies, users, and pricing.",
    confirmRevokeAdmin: "Revoke Admin Rights?",
    confirmRevokeAdminDesc: "This will remove admin access from this user. They will keep their employer/employee role.",
    grantAdmin: "Grant Admin",
    revokeAdminBtn: "Revoke",
    paymentHistory: "View payment history and transactions",
    noTransactions: "No transactions found",
    amount: "Amount",
    date: "Date",
    paid: "Paid",
    setCustomEnterprise: "Set Custom Enterprise Pricing",
    customEnterpriseDesc: "Set custom pricing for enterprise plans with specific employee limits.",
    pricePerMonth: "Price per Month (SAR)",
    maxEmployeesLimit: "Maximum Employees",
    createStripePrice: "Create Stripe Price",
    customPricingSet: "Custom enterprise pricing set",
    generateCheckoutLink: "Generate Checkout Link",
    removeCustomPricing: "Remove custom pricing",
    customPricingRemoved: "Custom enterprise pricing removed",
    confirmDelete: "Confirm",
    clearShifts: "Clear Shifts",
    allShiftsCleared: "All shifts cleared",
    na: "N/A",
    admin: "Admin",
    employer: "Employer",
    employeeRole: "Employee",
    starter: "Starter",
    growth: "Growth",
    business: "Business",
    professional: "Professional",
    enterprise: "Enterprise",
    trial: "Trial",
    canceled: "Canceled",
    pastDue: "Past Due",
    
    // Contact Page
    contactTitle: "Contact Us",
    contactSubtitle: "Get in touch with our team for Enterprise solutions",
    sendMessage: "Send us a Message",
    contactFormDesc: "Fill out the form and we'll get back to you within 24-48 hours.",
    fullName: "Full Name",
    enterName: "Enter your name",
    enterEmail: "Enter your email",
    enterCompany: "Enter company name",
    enterPhone: "+966 xxx xxx xxxx",
    enterMessage: "Tell us about your needs...",
    employeeCount: "Number of Employees",
    selectRange: "Select range",
    fillAllFields: "Please fill all required fields",
    messageSent: "Message sent successfully!",
    messageFailed: "Failed to send message",
    thankYou: "Thank You!",
    contactSuccess: "Your message has been sent successfully. Our team will contact you within 24-48 hours.",
    enterpriseBenefits: "Enterprise Benefits",
    unlimitedEmployees: "Unlimited Employees",
    unlimitedEmployeesDesc: "No limits on team size",
    dedicatedSupport: "Dedicated Support",
    dedicatedSupportDesc: "Priority support with dedicated account manager",
    customIntegrations: "Custom Integrations",
    customIntegrationsDesc: "Connect with your existing HR systems",
    directContact: "Direct Contact",
    
    // Privacy Policy Page
    backToHome: "Back to Home",
    privacyLastUpdateDate: "February 2025",
    "privacy.section1Title": "1. Information We Collect",
    "privacy.section1Intro": "GeoCheck collects the following types of information:",
    "privacy.personalInfo": "Personal Information",
    "privacy.personalInfo1": "Name and email address (via Google Sign-in or Email registration)",
    "privacy.personalInfo2": "Profile picture (optional, from Google account)",
    "privacy.personalInfo3": "Company name and role",
    "privacy.personalInfo4": "Custom display name (if set)",
    "privacy.locationData": "Location Data",
    "privacy.locationData1": "GPS coordinates at check-in and check-out times only",
    "privacy.locationData2": "We do NOT track location continuously",
    "privacy.locationData3": "Location data is used solely for attendance verification",
    "privacy.technicalData": "Technical Data",
    "privacy.technicalData1": "IP address (for security monitoring)",
    "privacy.technicalData2": "Browser type and device information",
    "privacy.technicalData3": "Session data and cookies",
    "privacy.section2Title": "2. How We Use Your Information",
    "privacy.howWeUse1": "To verify employee attendance at check-in/out",
    "privacy.howWeUse2": "To provide attendance reports and analytics",
    "privacy.howWeUse3": "To manage shift schedules and time-off requests",
    "privacy.howWeUse4": "To detect and alert on suspicious login activity",
    "privacy.howWeUse5": "To improve and maintain the Service",
    "privacy.section3Title": "3. Data Sharing",
    "privacy.dataShareIntro": "We do not sell your personal information. Data may be shared:",
    "privacy.dataShare1": "With your employer (attendance records, location at check-in/out)",
    "privacy.dataShare2": "With service providers who assist in operating our Service",
    "privacy.dataShare3": "When required by law or legal process",
    "privacy.section4Title": "4. Data Retention",
    "privacy.dataRetention": "We retain your data for as long as your account is active or as needed to provide services. Attendance records are retained for 3 years for compliance purposes. You may request deletion of your account at any time.",
    "privacy.section5Title": "5. Data Security",
    "privacy.dataSecurityIntro": "We implement industry-standard security measures including:",
    "privacy.dataSecurity1": "Encryption of data in transit (HTTPS/TLS)",
    "privacy.dataSecurity2": "Secure authentication via Google OAuth or Email/Password",
    "privacy.dataSecurity3": "Regular security audits and monitoring",
    "privacy.dataSecurity4": "Access controls and audit logging",
    "privacy.section6Title": "6. Your Rights",
    "privacy.yourRightsIntro": "You have the right to:",
    "privacy.yourRights1": "Access your personal data",
    "privacy.yourRights2": "Correct inaccurate data",
    "privacy.yourRights3": "Request deletion of your data",
    "privacy.yourRights4": "Export your attendance records",
    "privacy.yourRights5": "Opt out of non-essential communications",
    "privacy.section7Title": "7. Location Permissions",
    "privacy.locationPermissions": "GeoCheck requires location access only at the moment of check-in or check-out. You can deny location access, but this will prevent you from using the attendance features. We never access your location in the background.",
    "privacy.section8Title": "8. Changes to This Policy",
    "privacy.policyChanges": "We may update this Privacy Policy periodically. We will notify you of significant changes via email or in-app notification.",
    "privacy.section9Title": "9. Contact Us",
    "privacy.contactIntro": "For privacy-related questions or to exercise your rights, contact us at:",
    
    // Terms of Service Page
    termsLastUpdateDate: "February 2025",
    "terms.section1Title": "1. Acceptance of Terms",
    "terms.section1Content": "By accessing and using GeoCheck (\"the Service\"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the Service.",
    "terms.section2Title": "2. Description of Service",
    "terms.section2Intro": "GeoCheck is a GPS-based employee attendance tracking system that allows employers to monitor employee check-ins and check-outs, manage schedules, and generate reports. The Service includes:",
    "terms.service1": "GPS-verified employee check-in/out functionality",
    "terms.service2": "Real-time attendance dashboard",
    "terms.service3": "Shift scheduling and management",
    "terms.service4": "Time-off request management",
    "terms.service5": "Payroll and analytics reporting",
    "terms.section3Title": "3. User Accounts",
    "terms.section3Intro": "To use the Service, you must:",
    "terms.account1": "Be at least 18 years of age",
    "terms.account2": "Provide accurate and complete registration information",
    "terms.account3": "Maintain the security of your account credentials",
    "terms.account4": "Accept responsibility for all activities under your account",
    "terms.section4Title": "4. Subscription and Payment",
    "terms.section4Intro": "GeoCheck offers multiple subscription plans:",
    "terms.planStarter": "Free Trial",
    "terms.planStarterDesc": "10-day trial with up to 5 employees",
    "terms.planGrowth": "Growth Plan",
    "terms.planGrowthDesc": "Monthly subscription for up to 20 employees",
    "terms.planBusiness": "Business Plan",
    "terms.planBusinessDesc": "Monthly subscription for up to 60 employees",
    "terms.planEnterprise": "Enterprise",
    "terms.planEnterpriseDesc": "Custom pricing for larger organizations",
    "terms.paymentNote": "Payments are processed monthly. You may cancel at any time, but refunds are not provided for partial months.",
    "terms.section5Title": "5. Data Collection and Privacy",
    "terms.section5Content": "By using the Service, you consent to the collection of location data for attendance verification purposes. Please review our Privacy Policy for detailed information about data handling practices.",
    "terms.section6Title": "6. Acceptable Use",
    "terms.section6Intro": "You agree not to:",
    "terms.acceptable1": "Use the Service for any illegal purpose",
    "terms.acceptable2": "Attempt to bypass security measures",
    "terms.acceptable3": "Share login credentials with unauthorized users",
    "terms.acceptable4": "Use location spoofing or falsify attendance records",
    "terms.acceptable5": "Interfere with the proper functioning of the Service",
    "terms.section7Title": "7. Limitation of Liability",
    "terms.section7Content": "GeoCheck is provided \"as is\" without warranties of any kind. We are not liable for any indirect, incidental, or consequential damages arising from your use of the Service.",
    "terms.section8Title": "8. Changes to Terms",
    "terms.section8Content": "We reserve the right to modify these terms at any time. Continued use of the Service after changes constitutes acceptance of the new terms.",
    "terms.section9Title": "9. Contact",
    "terms.section9Content": "For questions about these Terms, please contact us at:"
  },
  
  ar: {
    appName: "GeoCheck",
    signIn: "تسجيل الدخول",
    signOut: "تسجيل الخروج",
    loading: "جاري التحميل...",
    workLocationStatus: "حالة موقع العمل",
    checkingLocationStatus: "جارٍ التحقق من حالة الموقع...",
    insideAllowedArea: "داخل النطاق المسموح",
    outsideAllowedArea: "خارج النطاق المسموح",
    assignedLocations: "المواقع المعينة",
    allowedRadius: "النطاق المسموح",
    geofenceNoAssignment: "يجب على صاحب العمل تعيين موقع عمل لك أولاً.",
    geofenceOutside: "أنت خارج نطاق تسجيل الحضور المسموح.",
    save: "حفظ",
    cancel: "إلغاء",
    submit: "إرسال",
    refresh: "تحديث",
    history: "السجل",
    settings: "الإعدادات",
    profile: "الملف الشخصي",
    actions: "الإجراءات",
    status: "الحالة",
    remove: "إزالة",
    approve: "موافقة",
    deny: "رفض",
    pending: "قيد الانتظار",
    approved: "موافق عليه",
    denied: "مرفوض",
    assigned: "معين",
    heroTagline: "حضور موثق بنظام GPS",
    heroTitle: "تسجيل حضور موثق بـ",
    heroPrecision: "دقة الموقع والوقت",
    heroDescription: "كل تسجيل حضور موثق بموقع GPS ووقت الوردية. اعرف بالضبط متى وأين يسجل فريقك — بدون تخمين، بدون تلاعب.",
    heroTrust: "موثوق من فرق الورديات في البيع والضيافة والخدمات الميدانية",
    heroVerified: "تم التحقق من الموقع",
    getStartedFree: "ابدأ مجاناً",
    navFeatures: "المميزات",
    navPricing: "الأسعار",
    featuresTitle: "مصمم للحضور الدقيق والموثق",
    featuresSubtitle: "كل ميزة مصممة للتخلص من التتبع اليدوي وارتباك الحضور.",
    featureGPS: "التحقق من موقع GPS",
    featureGPSDesc: "كل تسجيل حضور يلتقط إحداثيات GPS دقيقة. تحقق من وجود فريقك في المكان الصحيح.",
    featureTime: "تتبع الوقت التلقائي",
    featureTimeDesc: "يتم التقاط الطوابع الزمنية تلقائياً — بدون إدخال يدوي، بدون سرقة وقت.",
    featureSchedule: "جدول المجموعة",
    featureScheduleDesc: "عرض تقويم على شكل فرق لإدارة الورديات ورؤية كل قوتك العاملة بنظرة واحدة.",
    featurePayroll: "تصدير الرواتب",
    featurePayrollDesc: "صدّر تقارير الحضور والساعات المفصلة بصيغة CSV أو PDF بنقرة واحدة.",
    featureTeam: "نظرة عامة على الفريق",
    featureTeamDesc: "لوحة تحكم في الوقت الفعلي تُظهر من يعمل، ومن متأخر، ومن في إجازة.",
    featureSecurity: "آمن وخاص",
    featureSecurityDesc: "يتم التقاط الموقع فقط عند التسجيل — وليس تتبع مستمر. خصوصية فريقك مهمة.",
    featureAnalytics: "تحليلات على مستوى الشركة",
    featureAnalyticsDesc: "تتبع معدلات الحضور وأنماط التأخير وساعات العمل وأداء الفريق عبر مؤسستك بأكملها.",
    coreFeature: "ميزة أساسية",
    mostUsed: "الأكثر استخداماً",
    mobileTagline: "تصميم للجوال أولاً",
    mobileTitle: "سجل من أي مكان",
    mobileDescription: "يمكن لفريقك التسجيل بنقرة واحدة.",
    mobileFeature1: "تسجيل دخول وخروج بنقرة واحدة",
    mobileFeature2: "التقاط تلقائي لموقع GPS",
    mobileFeature3: "عرض سجل الحضور",
    mobileFeature4: "يعمل بدون إنترنت",
    ctaTitle: "توقف عن التخمين. ابدأ بالتحقق.",
    ctaDescription: "تخلص من التتبع اليدوي، وامنع سرقة الوقت، وأنهِ ارتباك الحضور. GeoCheck يمنحك الدقة التي يحتاجها عملك.",
    welcomeTitle: "مرحباً",
    roleQuestion: "هل أنت صاحب عمل أم موظف؟",
    imEmployer: "أنا صاحب عمل",
    employerDesc: "أنشئ شركة وادعُ الموظفين.",
    imEmployee: "أنا موظف",
    employeeDesc: "انضم برمز الدعوة.",
    createCompany: "أنشئ شركتك",
    joinCompany: "انضم لشركتك",
    companyNameLabel: "اسم الشركة",
    companyNamePlaceholder: "أدخل اسم شركتك",
    inviteCodeLabel: "رمز الدعوة",
    inviteCodePlaceholder: "أدخل رمز الدعوة",
    displayNameLabel: "اسمك الكامل",
    displayNamePlaceholder: "أدخل اسمك الكامل",
    displayNameHelp: "هذا هو الاسم الذي سيراه صاحب العمل",
    joiningCompany: "الانضمام إلى",
    continue: "متابعة",
    currentlyCheckedIn: "مسجل حالياً",
    notCheckedIn: "غير مسجل",
    checkIn: "تسجيل الدخول",
    checkOut: "تسجيل الخروج",
    gettingLocation: "جاري الحصول على الموقع...",
    activityHistory: "سجل النشاط",
    noActivity: "لا يوجد نشاط لهذا التاريخ",
    checkedIn: "تسجيل دخول",
    checkedOut: "تسجيل خروج",
    late: "متأخر",
    onTime: "في الوقت",
    requestTimeOff: "طلب إجازة",
    timeOffRequests: "طلبات الإجازة",
    selectDate: "اختر التاريخ",
    reasonType: "السبب",
    reasonDetails: "تفاصيل إضافية (اختياري)",
    reasonDetailsPlaceholder: "أدخل أي معلومات إضافية...",
    submitRequest: "إرسال الطلب",
    noTimeOffRequests: "لا توجد طلبات إجازة",
    realTimeAttendance: "لوحة تحكم حضور الموظفين",
    inviteCode: "رمز الدعوة",
    totalEmployees: "إجمالي الموظفين",
    currentlyWorking: "يعملون حالياً",
    notCheckedInCount: "غير مسجلين",
    employeeStatus: "حالة الموظفين",
    realTimeStatus: "حالة التسجيل في الوقت الفعلي",
    noEmployeesYet: "لا يوجد موظفون بعد",
    shareInviteCode: "شارك رمز الدعوة مع الموظفين",
    employee: "الموظف",
    lastCheckIn: "آخر تسجيل",
    lastLocation: "آخر موقع",
    working: "يعمل",
    offline: "غير متصل",
    timeOff: "إجازة",
    analytics: "التحليلات",
    viewAnalytics: "عرض التحليلات",
    period: "الفترة",
    week: "أسبوع",
    month: "شهر",
    year: "سنة",
    totalDaysWorked: "إجمالي أيام العمل",
    lateDays: "أيام التأخير",
    onTimeDays: "أيام الحضور في الوقت",
    totalHours: "إجمالي الساعات",
    avgHoursPerDay: "متوسط الساعات/اليوم",
    attendanceRate: "معدل الحضور",
    dailyBreakdown: "التفصيل اليومي",
    employeeManagement: "إدارة الموظفين",
    manageEmployees: "إدارة الموظفين",
    allEmployees: "جميع الموظفين",
    removeEmployee: "إزالة الموظف",
    confirmRemove: "هل أنت متأكد أنك تريد إزالة هذا الموظف؟",
    employeeRemoved: "تمت إزالة الموظف بنجاح",
    companySettings: "إعدادات الشركة",
    autoReset: "إعادة تعيين الحالة التلقائي",
    autoResetDesc: "إعادة تعيين حالة الموظفين الذين نسوا تسجيل الخروج",
    runNow: "تشغيل الآن",
    clearLateNotifications: "مسح إشعارات التأخير",
    clearLateNotificationsDesc: "أرشفة جميع إشعارات التأخير",
    languageSettings: "اللغة",
    selectLanguage: "اختر اللغة",
    securityAlerts: "تنبيهات الأمان",
    ipFlags: "تنبيهات IP",
    ipFlagDescription: "تسجيل دخول عدة موظفين من نفس الجهاز",
    noSecurityAlerts: "لا توجد تنبيهات أمان",
    flaggedUsers: "المستخدمون المُعلَّمون",
    checkInSuccess: "تم تسجيل الدخول بنجاح!",
    checkOutSuccess: "تم تسجيل الخروج بنجاح!",
    profileUpdated: "تم تحديث الملف الشخصي",
    settingsSaved: "تم حفظ الإعدادات",
    requestSubmitted: "تم إرسال الطلب",
    copiedToClipboard: "تم النسخ!",
    locationDenied: "تم رفض الوصول للموقع",
    // Pay Types
    payType: "نوع الدفع",
    hourly: "بالساعة",
    salary: "راتب",
    hourlyDesc: "جدولة مرنة بالورديات",
    salaryDesc: "جداول أسبوعية ثابتة",
    payTypeLabel: "نوع دفع الموظف",
    hourlyPayTypeHelp: "الموظفون يطلبون ورديات أو يُعيَّنون بورديات",
    salaryPayTypeHelp: "تعيين جداول أسبوعية دائمة للموظفين",
    // Permanent Schedule
    setSchedule: "تعيين الجدول الأسبوعي",
    settingScheduleFor: "تعيين جدول لـ",
    pendingSchedules: "الموظفون بحاجة لجداول",
    myPermanentSchedule: "جدولي الأسبوعي",
    permanentScheduleDesc: "ساعات عملك المنتظمة المحددة من قبل صاحب العمل",
    requestScheduleAdjustment: "طلب تعديل الجدول",
    scheduleSet: "تم تعيين الجدول بنجاح",
    dayOff: "يوم إجازة",
    salaryScheduleNote: "عرض الجداول الدائمة. تعديلات الورديات والإجازات تتجاوز الأوقات الدائمة.",
    permanentSchedule: "الجدول الدائم",
    shiftAdjustment: "وردية / تعديل",
    // Days of week
    monday: "الإثنين",
    tuesday: "الثلاثاء",
    wednesday: "الأربعاء",
    thursday: "الخميس",
    friday: "الجمعة",
    saturday: "السبت",
    sunday: "الأحد",
    // Employee actions
    jobTitle: "المسمى الوظيفي",
    jobTitlePlaceholder: "مثال: مهندس برمجيات",
    leaveCompany: "مغادرة الشركة",
    leaveCompanyConfirm: "هل أنت متأكد أنك تريد مغادرة هذه الشركة؟ لا يمكن التراجع عن هذا الإجراء.",
    leave: "مغادرة",
    leftCompanySuccess: "تمت مغادرة الشركة بنجاح",
    // Shift Scheduling
    schedule: "الجدول",
    groupSchedule: "جدول المجموعة",
    mySchedule: "جدولي",
    shiftRequests: "طلبات الورديات",
    requestShift: "طلب وردية",
    assignShift: "تعيين وردية",
    availability: "التوفر",
    setAvailability: "تعيين التوفر",
    myAvailability: "توفري",
    startTime: "وقت البداية",
    endTime: "وقت النهاية",
    shiftDate: "تاريخ الوردية",
    noShifts: "لا توجد ورديات مجدولة",
    noShiftRequests: "لا توجد طلبات ورديات",
    shiftApproved: "تمت الموافقة على الوردية",
    shiftDenied: "تم رفض الوردية",
    shiftAssigned: "تم تعيين الوردية",
    weeklySchedule: "الجدول الأسبوعي",
    previousWeek: "الأسبوع السابق",
    nextWeek: "الأسبوع القادم",
    today: "اليوم",
    todayShift: "وردية اليوم",
    timeOffRemoved: "تم إزالة الإجازة",
    removeTimeOff: "إزالة الإجازة",
    monday: "الاثنين",
    tuesday: "الثلاثاء",
    wednesday: "الأربعاء",
    thursday: "الخميس",
    friday: "الجمعة",
    saturday: "السبت",
    sunday: "الأحد",
    available: "متاح",
    notAvailable: "غير متاح",
    // Export
    exportReport: "تصدير التقرير",
    exportPayroll: "تصدير كشف الرواتب",
    downloadCSV: "تحميل CSV",
    startDate: "تاريخ البداية",
    endDate: "تاريخ النهاية",
    export: "تصدير",
    // Reasons
    "reasons.sick": "إجازة مرضية",
    "reasons.personal": "يوم شخصي",
    "reasons.vacation": "إجازة",
    "reasons.family_emergency": "طوارئ عائلية",
    "reasons.appointment": "موعد",
    "reasons.other": "أخرى",
    // New features
    totalAnalytics: "التحليلات الإجمالية",
    companyAnalytics: "تحليلات الشركة",
    exportSchedule: "تصدير الجدول",
    weeklyExport: "تصدير أسبوعي",
    monthlyExport: "تصدير شهري",
    lateReason: "سبب التأخير",
    enterLateReason: "يرجى إدخال سبب تسجيل الدخول المتأخر",
    lateReasonPlaceholder: "أدخل السبب...",
    flaggedIP: "تنبيه: نفس IP كموظف آخر",
    flaggedLate: "تنبيه: تسجيل دخول متأخر",
    employerNotes: "ملاحظات صاحب العمل",
    addNotes: "إضافة ملاحظات",
    notesPlaceholder: "أدخل ملاحظات للموظف...",
    shiftsEnabled: "جدولة الورديات مفعلة",
    shiftsDisabled: "جدولة الورديات معطلة",
    enableShifts: "تفعيل الورديات",
    disableShifts: "تعطيل الورديات",
    companyTimezone: "المنطقة الزمنية للشركة",
    timezoneHelp: "تستخدم لاكتشاف التأخير وأوقات الجدول",
    dateRange: "نطاق التاريخ",
    excludeDays: "استثناء أيام",
    selectDaysToExclude: "اختر الأيام للاستثناء",
    bulkApprove: "موافقة جماعية",
    bulkDeny: "رفض جماعي",
    viewLiveStatus: "الحالة المباشرة",
    viewAllEmployees: "جميع الموظفين",
    // General Arabic
    singleDay: "يوم واحد",
    dateRange: "نطاق التواريخ",
    excludeDays: "استثناء الأيام",
    selectDaysToExclude: "انقر على الأيام لاستثنائها من النطاق",
    monday: "الإثنين",
    tuesday: "الثلاثاء",
    wednesday: "الأربعاء",
    thursday: "الخميس",
    friday: "الجمعة",
    saturday: "السبت",
    sunday: "الأحد",
    // Pricing
    freeTrial: "تجربة مجانية",
    basicPlan: "الباقة الأساسية",
    proPlan: "الباقة الاحترافية",
    enterprisePlan: "الباقة المؤسسية",
    perMonth: "/شهر",
    contactUs: "اتصل بنا",
    startFreeTrial: "ابدأ التجربة المجانية",
    getStarted: "ابدأ الآن",
    // New Pricing
    pricingTitle: "أسعار بسيطة لكل حجم فريق",
    pricingSubtitle: "جميع الباقات تشمل جميع المميزات. اختر بناءً على حجم فريقك.",
    welcomeNewEmployer: "مرحباً بك في GeoCheck!",
    welcomeNewEmployerDesc: "تم إنشاء شركتك. اختر باقة لفتح جميع المميزات، أو تابع مع التجربة المجانية لمدة 10 أيام.",
    skipForNow: "تخطي الآن",
    goToDashboard: "الذهاب للوحة التحكم",
    planStarter: "المبتدئ",
    planStarterDesc: "جرب جميع المميزات مجاناً",
    planStarterTeam: "حتى 5 موظفين",
    planStarterFeature1: "10 أيام تجربة مجانية",
    planStarterFeature2: "لا يتطلب بطاقة ائتمان",
    planGrowth: "النمو",
    planGrowthDesc: "مثالي للفرق الصغيرة",
    planGrowthTeam: "حتى 20 موظف",
    planGrowthFeature1: "دعم عبر البريد",
    planGrowthFeature2: "حساب مدير واحد",
    planBusiness: "الأعمال",
    planBusinessDesc: "الأفضل للشركات النامية",
    planBusinessTeam: "حتى 60 موظف",
    planBusinessFeature1: "دعم أولوية",
    planBusinessFeature2: "مدراء غير محدودين",
    planBusinessFeature3: "تحليلات متقدمة",
    planProfessional: "الاحترافي",
    planProfessionalDesc: "للشركات الراسخة",
    planProfessionalTeam: "حتى 100 موظف",
    planProfessionalFeature1: "دعم أولوية",
    planProfessionalFeature2: "تحليلات متقدمة",
    planProfessionalFeature3: "تقارير مخصصة",
    planEnterprise: "المؤسسات",
    planEnterpriseDesc: "للمؤسسات الكبيرة",
    planEnterpriseTeam: "موظفين غير محدودين",
    planEnterpriseFeature1: "مدير حساب مخصص",
    planEnterpriseFeature2: "تكاملات مخصصة",
    planEnterpriseFeature3: "ضمان SLA",
    planBusinessFeature2: "مدراء بلا حدود",
    planBusinessFeature3: "تحليلات متقدمة",
    planEnterprise: "المؤسسات",
    planEnterpriseDesc: "للمؤسسات الكبيرة",
    planEnterpriseTeam: "أكثر من 100 موظف",
    planEnterpriseFeature1: "مدير حساب مخصص",
    planEnterpriseFeature2: "تكاملات مخصصة",
    planEnterpriseFeature3: "ضمان SLA",
    allFeaturesIncluded: "جميع المميزات مشمولة",
    // Footer
    footerTagline: "حضور موثق بـ GPS للفرق الحديثة",
    footerTrust: "مصمم لفرق الورديات في البيع والضيافة والخدمات الميدانية",
    footerProduct: "المنتج",
    footerSupport: "الدعم",
    footerLegal: "قانوني",
    // Legal
    termsOfService: "شروط الخدمة",
    privacyPolicy: "سياسة الخصوصية",
    allRightsReserved: "جميع الحقوق محفوظة",
    // Clear & Audit
    clearAll: "مسح الكل",
    auditHistory: "سجل التدقيق",
    resetAnalytics: "إعادة تعيين التحليلات",
    // Employer Dashboard UX - Iteration 11
    currentlyWorkingNow: "يعملون حالياً (الآن)",
    lateToday: "متأخرون اليوم",
    liveStatusHelper: "يتم تحديث الحالة المباشرة تلقائياً كل 30 ثانية",
    viewActivity: "عرض النشاط",
    dangerZone: "منطقة الخطر",
    deleteCompany: "حذف الشركة",
    deleteCompanyTitle: "حذف الشركة؟",
    deleteCompanyWarning: "سيؤدي هذا الإجراء إلى حذف شركتك وجميع البيانات المرتبطة بها بشكل دائم.",
    finalConfirmation: "مطلوب تأكيد نهائي",
    deleteCompanyFinalWarning: "أنت على وشك حذف شركتك بشكل دائم. لا يمكن التراجع عن هذا الإجراء.",
    allEmployeesRemoved: "سيتم إزالة جميع الموظفين من الشركة",
    allDataDeleted: "سيتم حذف جميع الورديات وطلبات الإجازة والتحليلات",
    subscriptionCancelled: "سيتم إلغاء اشتراكك",
    typeDelete: "اكتب",
    toConfirm: "للتأكيد",
    attendanceAlerts: "تنبيهات الحضور",
    attendanceAlertsDesc: "تشير تسجيلات الدخول المتأخرة إلى مشاكل محتملة في الجدولة أو النقل.",
    ipFlagExplanation: "تكتشف تنبيهات IP عندما يسجل عدة موظفين من نفس الجهاز/الشبكة.",
    noSecurityAlertsHelper: "لم يتم اكتشاف نشاط تسجيل دخول مشبوه",
    auditHistoryDesc: "يتم أرشفة البيانات الممسوحة هنا للمساءلة والامتثال.",
    shiftRequestsDesc: "مراجعة والموافقة على طلبات ورديات الموظفين",
    shiftRequestsEmptyHelper: "ستظهر طلبات الورديات من الموظفين هنا",
    timeOffRequestsDesc: "مراجعة والموافقة على طلبات إجازة الموظفين",
    timeOffRequestsEmptyHelper: "ستظهر طلبات الإجازة من الموظفين هنا",
    // Employee Dashboard UX - Phase 10
    noActivityHelp: "ستظهر تسجيلات الدخول والخروج هنا",
    checkInMicrocopy: "سيتم تسجيل موقع GPS الخاص بك للتحقق من الحضور",
    checkOutMicrocopy: "انقر لتسجيل وقت وموقع مغادرتك",
    howCheckInWorks: "كيف يعمل تسجيل الدخول",
    helpStep1Title: "التقاط موقع GPS",
    helpStep1Desc: "يتم تسجيل موقعك فقط في لحظة تسجيل الدخول أو الخروج — لا يتم تتبعك بينهما.",
    helpStep2Title: "اكتشاف التأخير",
    helpStep2Desc: "إذا سجلت دخولك بعد وقت بداية جدولك، سيتم تسجيلك متأخراً وسيُطلب منك سبب.",
    helpStep3Title: "تسجيل الخروج",
    helpStep3Desc: "لا تنسَ تسجيل الخروج عند المغادرة. إذا نسيت، ستُعاد حالتك تلقائياً في اليوم التالي.",
    helpPrivacyNote: "خصوصيتك مهمة. يتم التقاط بيانات الموقع فقط أثناء تسجيل الدخول/الخروج.",
    gotIt: "فهمت",
    shiftRequestsHelp: "تتبع طلباتك وردود صاحب العمل",
    noShiftRequestsHelp: "أرسل طلباً باستخدام النموذج على اليسار",
    timeOffRequestsHelp: "طلباتك المقدمة وحالتها",
    noTimeOffRequestsHelp: "أرسل طلباً باستخدام النموذج على اليسار",
    trialActive: "الفترة التجريبية للشركة نشطة",
    trialEmployeeNote: "تنتهي فترة صاحب العمل التجريبية في",
    days: "أيام",
    hours: "ساعات",
    you: "أنت",
    yourShifts: "ورديتك مميزة",
    // Subscription
    manageSubscription: "إدارة الاشتراك",
    cancelSubscription: "إلغاء الاشتراك",
    cancelSubscriptionTitle: "إلغاء الاشتراك؟",
    cancelSubscriptionWarning: "سيتم إلغاء اشتراكك في نهاية فترة الفوترة الحالية. ستفقد الوصول إلى جميع الميزات المميزة.",
    subscriptionCancelledSuccess: "تم إلغاء اشتراكك",
    reactivateSubscription: "إعادة تفعيل الاشتراك",
    subscriptionStatus: "حالة الاشتراك",
    currentPlan: "الباقة الحالية",
    billingCycle: "دورة الفوترة",
    nextBillingDate: "تاريخ الفوترة القادم",
    // Additional translations
    freeTrialActive: "التجربة المجانية نشطة",
    remaining: "متبقي",
    employees: "موظفين",
    upgradeNow: "ترقية الآن",
    activeSubscription: "اشتراك نشط",
    plan: "باقة",
    ipFlag: "تنبيه IP",
    reason: "السبب",
    active: "نشط",
    // Analytics Tab
    companyWideMetrics: "مقاييس الحضور على مستوى الشركة",
    resetAll: "إعادة تعيين الكل",
    employeeBreakdown: "تفصيل الموظفين",
    rate: "المعدل",
    // Security Tab
    multipleLoginsFromDevice: "تسجيلات دخول متعددة من نفس الجهاز",
    ipAddress: "عنوان IP",
    // Audit History Tab
    all: "الكل",
    shifts: "الورديات",
    lateAlerts: "تنبيهات التأخير",
    clearedShiftRequests: "طلبات الورديات الممسوحة",
    clearedTimeOffRequests: "طلبات الإجازة الممسوحة",
    clearedIpFlags: "تنبيهات IP الممسوحة",
    clearedLateNotifications: "إشعارات التأخير الممسوحة",
    cleared: "ممسوح",
    lateCheckIn: "تسجيل دخول متأخر",
    // Subscription Auto-Renewal
    autoRenewalEnabled: "التجديد التلقائي مفعل",
    autoRenewalDisabled: "التجديد التلقائي معطل",
    monthlyBilling: "فوترة شهرية",
    subscriptionRenewsAutomatically: "يتجدد اشتراكك تلقائياً كل شهر",
    // Auth Page
    loginDescription: "تسجيل الدخول إلى حسابك",
    registerDescription: "إنشاء حساب جديد",
    fullName: "الاسم الكامل",
    enterName: "أدخل اسمك",
    email: "البريد الإلكتروني",
    enterEmail: "أدخل بريدك الإلكتروني",
    password: "كلمة المرور",
    enterPassword: "أدخل كلمة المرور",
    confirmPassword: "تأكيد كلمة المرور",
    confirmPasswordPlaceholder: "أكد كلمة المرور",
    signUp: "إنشاء حساب",
    createAccount: "إنشاء حساب",
    noAccount: "ليس لديك حساب؟",
    haveAccount: "لديك حساب بالفعل؟",
    backToHome: "العودة للرئيسية",
    passwordsDoNotMatch: "كلمات المرور غير متطابقة",
    passwordTooShort: "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
    nameRequired: "الاسم مطلوب",
    loginFailed: "فشل تسجيل الدخول",
    registrationFailed: "فشل التسجيل",
    loginSuccess: "مرحباً بعودتك!",
    accountCreated: "تم إنشاء الحساب!",
    networkError: "خطأ في الشبكة. حاول مرة أخرى.",
    pleaseWait: "يرجى الانتظار...",
    // Forgot Password
    forgotPassword: "نسيت كلمة المرور؟",
    forgotPasswordDesc: "أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة التعيين",
    sendResetLink: "إرسال رابط إعادة التعيين",
    resetEmailSent: "تم إرسال بريد إعادة تعيين كلمة المرور!",
    resetEmailSentDesc: "لقد أرسلنا رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني. يرجى التحقق من صندوق الوارد.",
    resetEmailFailed: "فشل إرسال بريد إعادة التعيين",
    checkYourEmail: "تحقق من بريدك للحصول على رابط إعادة التعيين",
    sending: "جاري الإرسال...",
    backToLogin: "العودة لتسجيل الدخول",
    resetPassword: "إعادة تعيين كلمة المرور",
    resetPasswordDesc: "أدخل كلمة المرور الجديدة أدناه",
    newPassword: "كلمة المرور الجديدة",
    passwordMinLength: "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
    invalidResetLink: "رابط إعادة التعيين غير صالح أو مفقود",
    resetFailed: "فشل إعادة تعيين كلمة المرور",
    passwordResetSuccess: "تم إعادة تعيين كلمة المرور بنجاح!",
    passwordResetSuccessDesc: "تم إعادة تعيين كلمة المرور بنجاح",
    canNowLogin: "يمكنك الآن تسجيل الدخول بكلمة المرور الجديدة",
    goToLogin: "انتقل إلى تسجيل الدخول",
    resetting: "جاري إعادة التعيين...",
    // Pricing Tab Admin
    pricingPlans: "خطط الأسعار",
    managePricing: "إدارة أسعار الاشتراك وحدود الموظفين",
    planName: "اسم الخطة",
    priceSAR: "السعر (ريال)",
    maxEmployees: "الحد الأقصى للموظفين",
    description: "الوصف",
    editPlan: "تعديل",
    savePlan: "حفظ",
    deletePlan: "حذف الخطة",
    deletePlanConfirm: "سيتم حذف خطة الأسعار هذه بشكل دائم.",
    planUpdated: "تم تحديث الخطة بنجاح",
    planDeleted: "تم حذف الخطة",
    customPrice: "سعر مخصص",
    multiEmployer: "أصحاب عمل متعددين",
    multiEmployerEnabled: "تم تفعيل أصحاب العمل المتعددين",
    multiEmployerDisabled: "تم تعطيل أصحاب العمل المتعددين",
    multiEmployerInvite: "دعوة صاحب عمل آخر",
    multiEmployerInviteDesc: "شارك هذا الرابط مع شخص آخر لدعوته كصاحب عمل لشركتك. سيكون لديه صلاحيات صاحب العمل الكاملة.",
    multiEmployerInviteNote: "ملاحظة: يجب على الشخص المدعو اختيار 'أنا صاحب عمل' وإدخال رمز الدعوة هذا أثناء التسجيل.",
    employerInviteLinkCopied: "تم نسخ رابط دعوة صاحب العمل!",
    employerInviteBanner: "لقد تمت دعوتك للانضمام إلى",
    asEmployer: "كصاحب عمل",
    joinAsEmployer: "الانضمام كصاحب عمل",
    joinAsEmployerDesc: "لقد تمت دعوتك للانضمام إلى هذه الشركة كصاحب عمل.",
    // Landing page dynamic pricing
    trialDays: "10 أيام",
    month: "شهر",
    upTo: "حتى",
    // Terms and Privacy
    termsTitle: "شروط الخدمة",
    privacyTitle: "سياسة الخصوصية",
    lastUpdated: "آخر تحديث",
    // Admin Access
    adminAccess: "صلاحيات المسؤول",
    manageAllUsersCompanies: "إدارة جميع المستخدمين والشركات والأسعار",
    openAdminDashboard: "لوحة المسؤول",
    unrestricted: "غير مقيد",
    adminCompany: "شركة المسؤول",
    checkoutLinkGenerated: "تم إنشاء رابط الدفع!",
    linkCopied: "تم نسخ الرابط!",
    generateLink: "إنشاء رابط",
    setCustomPricing: "تعيين سعر مخصص",
    // Admin Dashboard
    adminDashboard: "لوحة الإدارة",
    exitAdmin: "خروج من الإدارة",
    totalUsers: "إجمالي المستخدمين",
    companiesCount: "الشركات",
    activeSubscriptions: "الاشتراكات النشطة",
    trialUsers: "مستخدمو التجربة",
    companiesTab: "الشركات",
    usersTab: "المستخدمون",
    transactionsTab: "المعاملات",
    pricingTab: "الأسعار",
    manageCompanySubscriptions: "إدارة اشتراكات الشركات والتجارب",
    company: "الشركة",
    owner: "المالك",
    employeesCount: "الموظفون",
    trialDaysColumn: "أيام التجربة",
    customEnterprise: "مؤسسة مخصصة",
    multiEmployer: "أصحاب عمل متعددون",
    edit: "تعديل",
    set: "تعيين",
    link: "رابط",
    editCompany: "تعديل الشركة",
    subscriptionStatusLabel: "حالة الاشتراك",
    subscriptionPlanLabel: "خطة الاشتراك",
    trialDaysLabel: "أيام التجربة",
    manageTrial: "إدارة التجربة",
    addTrialDays: "إضافة أيام",
    setTrialDays: "تعيين الأيام",
    resetTrial: "إعادة تعيين التجربة",
    trialExtended: "تم تمديد التجربة",
    trialSet: "تم تعيين التجربة",
    trialResetSuccess: "تم إعادة تعيين التجربة إلى 10 أيام",
    manageUsers: "إدارة مستخدمي المنصة والصلاحيات",
    name: "الاسم",
    role: "الدور",
    joined: "تاريخ الانضمام",
    makeAdmin: "منح صلاحيات المسؤول",
    revokeAdmin: "إلغاء صلاحيات المسؤول",
    adminRightsGranted: "تم منح صلاحيات المسؤول",
    adminRightsRevoked: "تم إلغاء صلاحيات المسؤول",
    confirmMakeAdmin: "منح صلاحيات المسؤول؟",
    confirmMakeAdminDesc: "سيمنح هذا المستخدم صلاحيات كاملة لإدارة جميع الشركات والمستخدمين والأسعار.",
    confirmRevokeAdmin: "إلغاء صلاحيات المسؤول؟",
    confirmRevokeAdminDesc: "سيزيل هذا صلاحيات المسؤول من هذا المستخدم. سيحتفظ بدوره كصاحب عمل/موظف.",
    grantAdmin: "منح الصلاحيات",
    revokeAdminBtn: "إلغاء",
    paymentHistory: "عرض سجل الدفعات والمعاملات",
    noTransactions: "لا توجد معاملات",
    amount: "المبلغ",
    date: "التاريخ",
    paid: "مدفوع",
    setCustomEnterprise: "تعيين أسعار المؤسسات المخصصة",
    customEnterpriseDesc: "تعيين أسعار مخصصة لخطط المؤسسات مع حدود موظفين محددة.",
    pricePerMonth: "السعر شهرياً (ريال)",
    maxEmployeesLimit: "الحد الأقصى للموظفين",
    createStripePrice: "إنشاء سعر Stripe",
    customPricingSet: "تم تعيين أسعار المؤسسة المخصصة",
    generateCheckoutLink: "إنشاء رابط الدفع",
    removeCustomPricing: "إزالة السعر المخصص",
    customPricingRemoved: "تم إزالة أسعار المؤسسة المخصصة",
    confirmDelete: "تأكيد",
    clearShifts: "مسح الورديات",
    allShiftsCleared: "تم مسح جميع الورديات",
    na: "غير متاح",
    admin: "مسؤول",
    employer: "صاحب عمل",
    employeeRole: "موظف",
    starter: "مبتدئ",
    growth: "نمو",
    business: "أعمال",
    professional: "احترافي",
    enterprise: "مؤسسات",
    trial: "تجربة",
    canceled: "ملغي",
    pastDue: "متأخر",
    // Pricing Tab
    pricingPlans: "خطط الأسعار",
    managePricing: "إدارة أسعار الاشتراك وحدود الموظفين",
    planName: "اسم الخطة",
    priceSAR: "السعر (ريال)",
    maxEmployees: "الحد الأقصى للموظفين",
    description: "الوصف",
    deletePlan: "حذف الخطة",
    deletePlanConfirm: "سيتم حذف هذه الخطة نهائياً. لن تتأثر الشركات المشتركة حالياً، لكن لن يمكن استخدام هذه الخطة للاشتراكات الجديدة.",
    freeTrial: "مجاني",
    unlimited: "غير محدود",
    contactSales: "تواصل معنا",
    
    // Contact Page - Arabic
    contactTitle: "اتصل بنا",
    contactSubtitle: "تواصل مع فريقنا لحلول المؤسسات",
    sendMessage: "أرسل لنا رسالة",
    contactFormDesc: "املأ النموذج وسنعاود الاتصال بك خلال 24-48 ساعة.",
    fullName: "الاسم الكامل",
    enterName: "أدخل اسمك",
    enterEmail: "أدخل بريدك الإلكتروني",
    enterCompany: "أدخل اسم الشركة",
    enterPhone: "+966 xxx xxx xxxx",
    enterMessage: "أخبرنا عن احتياجاتك...",
    employeeCount: "عدد الموظفين",
    selectRange: "اختر النطاق",
    fillAllFields: "يرجى ملء جميع الحقول المطلوبة",
    messageSent: "تم إرسال الرسالة بنجاح!",
    messageFailed: "فشل في إرسال الرسالة",
    thankYou: "شكراً لك!",
    contactSuccess: "تم إرسال رسالتك بنجاح. سيتواصل معك فريقنا خلال 24-48 ساعة.",
    enterpriseBenefits: "مزايا المؤسسات",
    unlimitedEmployees: "موظفون غير محدودين",
    unlimitedEmployeesDesc: "لا حدود لحجم الفريق",
    dedicatedSupport: "دعم مخصص",
    dedicatedSupportDesc: "دعم ذو أولوية مع مدير حساب مخصص",
    customIntegrations: "تكاملات مخصصة",
    customIntegrationsDesc: "اتصل بأنظمة الموارد البشرية الحالية لديك",
    directContact: "الاتصال المباشر",
    
    // Privacy Policy Page - Arabic
    backToHome: "العودة للرئيسية",
    privacyLastUpdateDate: "فبراير 2025",
    "privacy.section1Title": "1. المعلومات التي نجمعها",
    "privacy.section1Intro": "يجمع GeoCheck أنواع المعلومات التالية:",
    "privacy.personalInfo": "المعلومات الشخصية",
    "privacy.personalInfo1": "الاسم وعنوان البريد الإلكتروني (عبر تسجيل الدخول بـ Google أو البريد الإلكتروني)",
    "privacy.personalInfo2": "صورة الملف الشخصي (اختيارية، من حساب Google)",
    "privacy.personalInfo3": "اسم الشركة والدور الوظيفي",
    "privacy.personalInfo4": "اسم العرض المخصص (إن تم تعيينه)",
    "privacy.locationData": "بيانات الموقع",
    "privacy.locationData1": "إحداثيات GPS في أوقات تسجيل الدخول والخروج فقط",
    "privacy.locationData2": "نحن لا نتتبع موقعك بشكل مستمر",
    "privacy.locationData3": "تُستخدم بيانات الموقع فقط للتحقق من الحضور",
    "privacy.technicalData": "البيانات التقنية",
    "privacy.technicalData1": "عنوان IP (للمراقبة الأمنية)",
    "privacy.technicalData2": "نوع المتصفح ومعلومات الجهاز",
    "privacy.technicalData3": "بيانات الجلسة وملفات تعريف الارتباط",
    "privacy.section2Title": "2. كيف نستخدم معلوماتك",
    "privacy.howWeUse1": "للتحقق من حضور الموظفين عند تسجيل الدخول/الخروج",
    "privacy.howWeUse2": "لتوفير تقارير وتحليلات الحضور",
    "privacy.howWeUse3": "لإدارة جداول الورديات وطلبات الإجازة",
    "privacy.howWeUse4": "لاكتشاف والتنبيه على نشاط تسجيل الدخول المشبوه",
    "privacy.howWeUse5": "لتحسين وصيانة الخدمة",
    "privacy.section3Title": "3. مشاركة البيانات",
    "privacy.dataShareIntro": "نحن لا نبيع معلوماتك الشخصية. قد تتم مشاركة البيانات:",
    "privacy.dataShare1": "مع صاحب العمل (سجلات الحضور، الموقع عند تسجيل الدخول/الخروج)",
    "privacy.dataShare2": "مع مقدمي الخدمات الذين يساعدون في تشغيل خدمتنا",
    "privacy.dataShare3": "عند الحاجة بموجب القانون أو الإجراءات القانونية",
    "privacy.section4Title": "4. الاحتفاظ بالبيانات",
    "privacy.dataRetention": "نحتفظ ببياناتك طالما كان حسابك نشطًا أو حسب الحاجة لتقديم الخدمات. يتم الاحتفاظ بسجلات الحضور لمدة 3 سنوات لأغراض الامتثال. يمكنك طلب حذف حسابك في أي وقت.",
    "privacy.section5Title": "5. أمان البيانات",
    "privacy.dataSecurityIntro": "نطبق إجراءات أمان قياسية تشمل:",
    "privacy.dataSecurity1": "تشفير البيانات أثناء النقل (HTTPS/TLS)",
    "privacy.dataSecurity2": "مصادقة آمنة عبر Google OAuth أو البريد الإلكتروني/كلمة المرور",
    "privacy.dataSecurity3": "تدقيقات ومراقبة أمنية منتظمة",
    "privacy.dataSecurity4": "ضوابط الوصول وتسجيل التدقيق",
    "privacy.section6Title": "6. حقوقك",
    "privacy.yourRightsIntro": "لديك الحق في:",
    "privacy.yourRights1": "الوصول إلى بياناتك الشخصية",
    "privacy.yourRights2": "تصحيح البيانات غير الدقيقة",
    "privacy.yourRights3": "طلب حذف بياناتك",
    "privacy.yourRights4": "تصدير سجلات حضورك",
    "privacy.yourRights5": "إلغاء الاشتراك من الاتصالات غير الضرورية",
    "privacy.section7Title": "7. أذونات الموقع",
    "privacy.locationPermissions": "يتطلب GeoCheck الوصول إلى الموقع فقط في لحظة تسجيل الدخول أو الخروج. يمكنك رفض الوصول إلى الموقع، لكن هذا سيمنعك من استخدام ميزات الحضور. نحن لا نصل أبدًا إلى موقعك في الخلفية.",
    "privacy.section8Title": "8. التغييرات على هذه السياسة",
    "privacy.policyChanges": "قد نقوم بتحديث سياسة الخصوصية هذه بشكل دوري. سنخطرك بالتغييرات المهمة عبر البريد الإلكتروني أو إشعار داخل التطبيق.",
    "privacy.section9Title": "9. اتصل بنا",
    "privacy.contactIntro": "للاستفسارات المتعلقة بالخصوصية أو لممارسة حقوقك، اتصل بنا على:",
    
    // Terms of Service Page - Arabic
    termsLastUpdateDate: "فبراير 2025",
    "terms.section1Title": "1. قبول الشروط",
    "terms.section1Content": "بالدخول واستخدام GeoCheck (\"الخدمة\")، فإنك توافق على الالتزام بشروط الخدمة هذه. إذا كنت لا توافق على هذه الشروط، يرجى عدم استخدام الخدمة.",
    "terms.section2Title": "2. وصف الخدمة",
    "terms.section2Intro": "GeoCheck هو نظام تتبع حضور الموظفين القائم على GPS يسمح لأصحاب العمل بمراقبة تسجيلات دخول وخروج الموظفين، وإدارة الجداول، وإنشاء التقارير. تشمل الخدمة:",
    "terms.service1": "وظيفة تسجيل دخول/خروج الموظفين الموثقة بـ GPS",
    "terms.service2": "لوحة حضور في الوقت الفعلي",
    "terms.service3": "جدولة وإدارة الورديات",
    "terms.service4": "إدارة طلبات الإجازة",
    "terms.service5": "تقارير الرواتب والتحليلات",
    "terms.section3Title": "3. حسابات المستخدمين",
    "terms.section3Intro": "لاستخدام الخدمة، يجب عليك:",
    "terms.account1": "أن يكون عمرك 18 عامًا على الأقل",
    "terms.account2": "تقديم معلومات تسجيل دقيقة وكاملة",
    "terms.account3": "الحفاظ على أمان بيانات اعتماد حسابك",
    "terms.account4": "قبول المسؤولية عن جميع الأنشطة تحت حسابك",
    "terms.section4Title": "4. الاشتراك والدفع",
    "terms.section4Intro": "يقدم GeoCheck خطط اشتراك متعددة:",
    "terms.planStarter": "التجربة المجانية",
    "terms.planStarterDesc": "تجربة لمدة 10 أيام مع ما يصل إلى 5 موظفين",
    "terms.planGrowth": "خطة النمو",
    "terms.planGrowthDesc": "اشتراك شهري لما يصل إلى 20 موظف",
    "terms.planBusiness": "خطة الأعمال",
    "terms.planBusinessDesc": "اشتراك شهري لما يصل إلى 60 موظف",
    "terms.planEnterprise": "المؤسسات",
    "terms.planEnterpriseDesc": "أسعار مخصصة للمؤسسات الأكبر",
    "terms.paymentNote": "تتم معالجة المدفوعات شهريًا. يمكنك الإلغاء في أي وقت، لكن لا يتم تقديم استرداد للأشهر الجزئية.",
    "terms.section5Title": "5. جمع البيانات والخصوصية",
    "terms.section5Content": "باستخدام الخدمة، فإنك توافق على جمع بيانات الموقع لأغراض التحقق من الحضور. يرجى مراجعة سياسة الخصوصية للحصول على معلومات مفصلة حول ممارسات معالجة البيانات.",
    "terms.section6Title": "6. الاستخدام المقبول",
    "terms.section6Intro": "توافق على عدم:",
    "terms.acceptable1": "استخدام الخدمة لأي غرض غير قانوني",
    "terms.acceptable2": "محاولة تجاوز إجراءات الأمان",
    "terms.acceptable3": "مشاركة بيانات اعتماد تسجيل الدخول مع مستخدمين غير مصرح لهم",
    "terms.acceptable4": "استخدام انتحال الموقع أو تزوير سجلات الحضور",
    "terms.acceptable5": "التدخل في العمل السليم للخدمة",
    "terms.section7Title": "7. تحديد المسؤولية",
    "terms.section7Content": "يتم تقديم GeoCheck \"كما هو\" دون ضمانات من أي نوع. نحن غير مسؤولين عن أي أضرار غير مباشرة أو عرضية أو تبعية ناشئة عن استخدامك للخدمة.",
    "terms.section8Title": "8. التغييرات على الشروط",
    "terms.section8Content": "نحتفظ بالحق في تعديل هذه الشروط في أي وقت. يشكل استمرار استخدام الخدمة بعد التغييرات قبولاً للشروط الجديدة.",
    "terms.section9Title": "9. الاتصال",
    "terms.section9Content": "للاستفسارات حول هذه الشروط، يرجى الاتصال بنا على:"
  },
  
  es: {
    appName: "GeoCheck",
    signIn: "Iniciar Sesión",
    signOut: "Cerrar sesión",
    loading: "Cargando...",
    save: "Guardar",
    cancel: "Cancelar",
    heroTagline: "Seguimiento de asistencia con GPS",
    heroTitle: "Rastrea los registros de empleados con",
    heroPrecision: "precisión",
    getStartedFree: "Comenzar Gratis",
    welcomeTitle: "Bienvenido",
    imEmployer: "Soy Empleador",
    imEmployee: "Soy Empleado",
    currentlyCheckedIn: "Actualmente Registrado",
    notCheckedIn: "No Registrado",
    checkIn: "Registrar Entrada",
    checkOut: "Registrar Salida",
    activityHistory: "Historial de Actividad",
    timeOffRequests: "Solicitudes de Tiempo Libre",
    schedule: "Horario",
    groupSchedule: "Horario Grupal",
    exportReport: "Exportar Informe",
    "reasons.sick": "Enfermedad",
    "reasons.personal": "Día Personal",
    "reasons.vacation": "Vacaciones",
    "reasons.family_emergency": "Emergencia Familiar",
    "reasons.appointment": "Cita",
    "reasons.other": "Otro"
  },
  
  fr: {
    appName: "GeoCheck",
    signIn: "Se Connecter",
    signOut: "Se déconnecter",
    loading: "Chargement...",
    heroTagline: "Suivi de présence par GPS",
    heroTitle: "Suivez les pointages avec",
    heroPrecision: "précision",
    getStartedFree: "Commencer Gratuitement",
    welcomeTitle: "Bienvenue",
    imEmployer: "Je suis Employeur",
    imEmployee: "Je suis Employé",
    checkIn: "Pointer Entrée",
    checkOut: "Pointer Sortie",
    currentlyCheckedIn: "Actuellement Pointé",
    notCheckedIn: "Non Pointé",
    activityHistory: "Historique",
    timeOffRequests: "Demandes de Congé",
    schedule: "Planning",
    groupSchedule: "Planning de Groupe",
    exportReport: "Exporter Rapport"
  },
  
  zh: {
    appName: "GeoCheck",
    signIn: "登录",
    signOut: "退出",
    loading: "加载中...",
    heroTagline: "GPS驱动的考勤跟踪",
    heroTitle: "精准追踪员工打卡",
    heroPrecision: "精准",
    getStartedFree: "免费开始",
    welcomeTitle: "欢迎",
    imEmployer: "我是雇主",
    imEmployee: "我是员工",
    checkIn: "上班打卡",
    checkOut: "下班打卡",
    currentlyCheckedIn: "已打卡",
    notCheckedIn: "未打卡",
    activityHistory: "活动历史",
    timeOffRequests: "请假记录",
    schedule: "排班",
    groupSchedule: "团队排班",
    exportReport: "导出报告"
  }
};

export const supportedLanguages = [
  { code: "en", name: "English", nativeName: "English", dir: "ltr" },
  { code: "ar", name: "Arabic", nativeName: "العربية", dir: "rtl" },
  { code: "es", name: "Spanish", nativeName: "Español", dir: "ltr" },
  { code: "fr", name: "French", nativeName: "Français", dir: "ltr" },
  { code: "zh", name: "Chinese", nativeName: "中文", dir: "ltr" }
];

export const getTranslation = (lang, key) => {
  const langData = translations[lang] || translations.en;
  return langData[key] || translations.en[key] || key;
};
